module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disk-share"
  }, [_c('div', {
    staticClass: "disk-share-brand"
  }, [_c('img', {
    attrs: {
      "src": _vm.folderIcon,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("网盘分享")])]), _vm._v(" "), _c('div', {
    class: ['disk-share-box', {
      wide: _vm.opened && _vm.share.nodeType !== 2
    }]
  }, [(_vm.loading) ? _c('div', {
    staticClass: "disk-share-state"
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  }), _vm._v(" "), _c('p', [_vm._v("正在打开分享…")])], 1) : (_vm.invalid) ? _c('div', {
    staticClass: "disk-share-state"
  }, [_c('img', {
    staticClass: "disk-share-state-icon dim",
    attrs: {
      "src": _vm.fileIcon,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "disk-share-state-title"
  }, [_vm._v(_vm._s(_vm.invalidMsg))]), _vm._v(" "), _c('p', [_vm._v("分享可能已过期或被撤销，请联系分享人重新分享")])]) : (_vm.needCode) ? _c('div', {
    staticClass: "disk-share-code"
  }, [_c('img', {
    staticClass: "disk-share-state-icon",
    attrs: {
      "src": _vm.folderIcon,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "disk-share-state-title"
  }, [_vm._v("请输入提取码")]), _vm._v(" "), _c('p', {
    staticClass: "disk-share-code-sub"
  }, [_vm._v("分享人设置了提取码，输入后即可查看文件")]), _vm._v(" "), _c('div', {
    staticClass: "disk-share-code-form"
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "提取码",
      "maxlength": 8
    },
    on: {
      "on-enter": _vm.openShare
    },
    model: {
      value: (_vm.extractCode),
      callback: function($$v) {
        _vm.extractCode = $$v
      },
      expression: "extractCode"
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.opening
    },
    on: {
      "click": _vm.openShare
    }
  }, [_vm._v("提取文件")])], 1), _vm._v(" "), (_vm.codeError) ? _c('p', {
    staticClass: "disk-share-error"
  }, [_vm._v(_vm._s(_vm.codeError))]) : _vm._e()]) : (_vm.opened) ? _c('div', [_c('div', {
    staticClass: "disk-share-hero"
  }, [_c('img', {
    staticClass: "disk-share-hero-icon",
    attrs: {
      "src": _vm.iconOf(_vm.share),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-share-hero-main"
  }, [_c('div', {
    staticClass: "disk-share-name",
    attrs: {
      "title": _vm.share.name
    }
  }, [_vm._v(_vm._s(_vm.share.name))]), _vm._v(" "), _c('div', {
    staticClass: "disk-share-meta"
  }, [(_vm.share.nodeType === 2) ? _c('span', [_vm._v(_vm._s(_vm.formatSize(_vm.share.size)))]) : _c('span', [_vm._v(_vm._s((_vm.share.children || []).length) + " 项")])])]), _vm._v(" "), (_vm.share.nodeType === 2) ? _c('div', {
    staticClass: "disk-share-hero-ops"
  }, [_c('Button', {
    attrs: {
      "size": "large",
      "icon": "ios-eye-outline"
    },
    on: {
      "click": function($event) {
        return _vm.preview(_vm.share.id, _vm.share)
      }
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "icon": "ios-download-outline"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.share.id)
      }
    }
  }, [_vm._v("下载")])], 1) : _vm._e()]), _vm._v(" "), (_vm.share.nodeType !== 2) ? _c('div', {
    staticClass: "disk-share-list"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.share.children || [],
      "no-data-text": "文件夹是空的"
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "disk-modal",
      "title": _vm.previewName,
      "width": "960"
    },
    on: {
      "on-visible-change": _vm.onPreviewVisible
    },
    model: {
      value: (_vm.showPreviewModal),
      callback: function($$v) {
        _vm.showPreviewModal = $$v
      },
      expression: "showPreviewModal"
    }
  }, [_c('div', {
    staticClass: "disk-preview",
    class: {
      'disk-preview-center': _vm.centerPreview
    }
  }, [(_vm.previewLoading) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("加载中...")]) : (_vm.previewError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v(_vm._s(_vm.previewError))]) : (_vm.previewType === 'image') ? _c('img', {
    staticClass: "disk-preview-image",
    attrs: {
      "src": _vm.previewUrl
    }
  }) : (_vm.previewType === 'pdf') ? _c('iframe', {
    staticClass: "disk-preview-frame",
    attrs: {
      "src": _vm.previewBlobUrl
    }
  }) : (_vm.previewType === 'video') ? [_c('video', {
    ref: "previewVideo",
    staticClass: "disk-preview-media",
    attrs: {
      "src": _vm.previewUrl,
      "controls": ""
    },
    on: {
      "error": _vm.onMediaError
    }
  }), _vm._v(" "), (_vm.mediaError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")]) : _vm._e()] : (_vm.previewType === 'audio') ? [_c('audio', {
    ref: "previewAudio",
    attrs: {
      "src": _vm.previewUrl,
      "controls": ""
    },
    on: {
      "error": _vm.onMediaError
    }
  }), _vm._v(" "), (_vm.mediaError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")]) : _vm._e()] : (_vm.previewType === 'office' && _vm.previewEngine === 'aliyun') ? [_c('div', {
    ref: "aliyunOffice",
    staticClass: "disk-preview-frame"
  })] : (_vm.previewType === 'office') ? [_c('iframe', {
    staticClass: "disk-preview-frame",
    attrs: {
      "src": _vm.officeUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-preview-hint"
  }, [_vm._v("若无法打开，请下载后查看")])] : (_vm.previewType === 'csv') ? [(_vm.previewEmpty) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("没有可预览的内容")]) : _c('div', {
    staticClass: "disk-preview-table-wrap"
  }, [_c('table', {
    staticClass: "disk-preview-table"
  }, [_c('tbody', _vm._l((_vm.previewRows), function(line, lineIndex) {
    return _c('tr', {
      key: lineIndex
    }, _vm._l((line), function(cell, cellIndex) {
      return _c('td', {
        key: cellIndex,
        class: {
          'disk-preview-th': lineIndex === 0
        }
      }, [_vm._v(_vm._s(cell))])
    }), 0)
  }), 0)])])] : (_vm.previewType === 'markdown') ? _c('div', {
    staticClass: "disk-preview-markdown",
    domProps: {
      "innerHTML": _vm._s(_vm.previewHtml)
    }
  }) : (_vm.previewType === 'json') ? [(_vm.jsonError) ? _c('div', {
    staticClass: "disk-preview-hint"
  }, [_vm._v("不是合法 JSON")]) : _vm._e(), _vm._v(" "), _c('pre', {
    staticClass: "disk-preview-pre"
  }, [_vm._v(_vm._s(_vm.previewText))])] : (_vm.previewType === 'text') ? _c('pre', {
    staticClass: "disk-preview-pre"
  }, [_vm._v(_vm._s(_vm.previewText))]) : _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-download"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.previewDownloadId)
      }
    }
  }, [_vm._v("下载")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a07b145a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/disk/DiskShare.vue
// module id = 1934
// module chunks = 8